import React, { useEffect, useState } from 'react';

import "./styles.css";

import {  FaFileInvoiceDollar, FaRegFolder } from 'react-icons/fa';
import Input from '../../../../../../components/Input';
import Popup from '../../../../../../components/Popup';
import productServices from '../../../../../../services/admFin/productServices';
import PopupNewProduct from '../../../../Stock/ProductsCard/PopupNewProduct';


export default function PopupSelectProducts(props) { 
    const [visibility, setVisibility] = useState(false);
    const [productPopup, setProductPopup] = useState(false);
    function onSelectProduct(key, name) {
        props.setProducts(oldArray => {
            const temp = [...oldArray];
            temp[key].nameRegistered = name;
            return temp;
        })
    }

    function onClick() {
        const products = {};
        for(const product of props.products) {
            if(!product.nameRegistered) {
                alert("Preencha todos os campos necessários");
                return;
            }
            const productRegistered = props.productsList.find(item => item.nome === product.nameRegistered);
            products[productRegistered.id] = {
                produto: productRegistered,
                quantidade: product.quantidade,
                valor_unidade: product.valor,
                icms: product.icms,
                pis: product.pis,
                cofins: product.cofins,
            }
        }
        props.setProductsBill(products);
        props.setVisibility(false);

    }

    function onClickCreate(e, product) {
        e.preventDefault();
        console.log(product.produto);
        setProductPopup(product.produto);
        setVisibility(true);
    }

    async function onCreate(data) {
        try {
            props.setProducts(oldArray => {
            const temp = oldArray.map(product => {
                if(product.produto === productPopup){
                    product.nameRegistered = data.nome;
                    }
                    return product;
                });
                
                return temp;
            })
            const response = await productServices.getProducts();
            props.setProductsList(response.data);
        } catch(e) {
            alert (e);
        }

    }

    return (
        <>
            <Popup
                visibility={props.visibility}
                setVisibility={props.setVisibility}
                icon={<FaFileInvoiceDollar />}
                tittle="Selecionar Produtos"
            >
                {
                    
                    props.products.map((product, key) => (
                        <div key={key}>
                            <p>Produto: {product.produto.nome}</p>
                            <div className='pop-up-select-products-buttons-container'>
                                <Input
                                    label='Produto associado*'
                                    type='select'
                                    //noFilterOptions
                                    options={props.productsList ? props.productsList.map(item => item.nome) : []}
                                    id='popup-select-products-product'
                                    onChange={(event) => onSelectProduct(key, event.target.value)}
                                    value={product.nameRegistered ? product.nameRegistered : ""}
                                />
                                <button onClick={(e) => onClickCreate(e, product)}>
                                    Criar Produto
                                </button>
                            </div>
                        
                        </div>
                    )) 
                    
                }
                
                <button type="button" onClick={onClick}>
                    Selecionar
                </button>
            </Popup>
            <PopupNewProduct
                visibility={visibility}
                setVisibility={setVisibility}
                data={productPopup}
                //criticalMode={props.criticalMode}
                onCreate={onCreate}
                //onUpdate={props.onUpdate}
            />
        </>
    )
}